import { isWindowDefined } from "../element";
import { isArray } from "../types";

export type LogColorType =
  | "red"
  | "green"
  | "yellow"
  | "blue"
  | "magenta"
  | "cyan"
  | "white"
  | "gray"
  | "orange"
  | "purple"
  | "pink"
  | "brown"
  | "lightBlue";

const terminalColors: Record<LogColorType, string> = {
  red: "\x1b[31m",
  green: "\x1b[32m",
  yellow: "\x1b[33m",
  blue: "\x1b[34m",
  magenta: "\x1b[35m",
  cyan: "\x1b[36m",
  white: "\x1b[37m",
  gray: "\x1b[90m",
  orange: "\x1b[38;5;208m",
  purple: "\x1b[38;5;129m",
  pink: "\x1b[38;5;219m",
  brown: "\x1b[38;5;130m",
  lightBlue: "\x1b[38;5;39m",
};

const browserColors: Record<LogColorType, string> = {
  red: "color: #FF0000",
  green: "color: #00FF00",
  yellow: "color: #FFFF00",
  blue: "color: #0000FF",
  magenta: "color: #FF00FF",
  cyan: "color: #00FFFF",
  white: "color: #FFFFFF",
  gray: "color: #808080",
  orange: "color: #FFA500",
  purple: "color: #800080",
  pink: "color: #FFC0CB",
  brown: "color: #A52A2A",
  lightBlue: "color: #ADD8E6",
};

export const log = (
  color: LogColorType,
  realm: string | string[],
  ...args: unknown[]
): void => {
  const time = new Date().toLocaleTimeString();
  const realmDisplay = `[${isArray(realm) ? realm.join(".") : realm}]`;

  if (isWindowDefined()) {
    console.log(`%c[${time}] ${realmDisplay}`, browserColors[color], ...args);
  } else {
    console.log(
      `${terminalColors[color]}[${time}] ${realmDisplay}\x1b[0m`,
      ...args,
    );
  }
};
